import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import {
  ApolloLink,
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import styled from 'styled-components';
import MainContextProvider from './context/MainProvider';
import { configureStore } from './redux/store';
import { ConfigProvider } from 'antd';
import Colors from './assets/values/Colors';

const App = React.lazy(() => import('./App'));

if (process.env.REACT_APP_MOCKS === 'true') {
  const { worker } = require('./api/mocks/browser');
  worker.start();
}

const errorLink = onError(({ graphQLErrors }) => {
  if (Array.isArray(graphQLErrors)) {
    const hasJwtError = graphQLErrors.some(
      ({ extensions }) => extensions.code === 'invalid-jwt',
    );
    if (hasJwtError) {
      console.error('Invalid JWT Token');
      localStorage.clear();
      window.location.href = '/';
    }
  }
});

const httpLink = createHttpLink({
  uri: window.REACT_APP_GRAPHQL_URL || process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:5012/v1/graphql',
  fetch: (...args) => fetch(...args),
  credentials: 'include',
});

const evaGraphQlHttpLink = createHttpLink({
  uri: window.REACT_APP_EVA_GRAPHQL_URL || process.env.REACT_APP_EVA_GRAPHQL_URL || 'http://localhost:5010/v1/graphql',
  fetch: (...args) => fetch(...args),
  credentials: 'include',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('access_token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
});

export const evaGraphQlClient = new ApolloClient({
  link: ApolloLink.from([authLink, errorLink, evaGraphQlHttpLink]),
  cache: new InMemoryCache(),
});

export function WrappedToastContainer({ className, ...rest }) {
  return (
    <div className={className}>
      <ToastContainer {...rest} />
    </div>
  );
}

const StyledToast = styled(WrappedToastContainer)`
  .Toastify__toast-container {
  }

  .Toastify__toast {
  }

  .Toastify__toast--error {
    //background: #a85252;
  }

  .Toastify__toast--warning {
  }

  .Toastify__toast--success {
    //background: #57ad66;
  }

  .Toastify__toast-body {
  }

  .Toastify__progress-bar {
  }
`;

ReactDOM.render(
  <Provider store={configureStore()}>
    <ApolloProvider client={client}>
      <MainContextProvider>
        <Suspense fallback={<div className="loading" />}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: Colors.primary,
                colorError: Colors.error,
              },
            }}
          >
            <App />
            <StyledToast position="bottom-right" pauseOnHover />
          </ConfigProvider>
        </Suspense>
      </MainContextProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root'),
);
